import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ddb4ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "annual-container",
  id: "annual-container"
}
const _hoisted_2 = { class: "cur-op" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "历史年度目标", -1))
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = { class: "cur-table" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "op" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!
  const _component_EditPop = _resolveComponent("EditPop")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleNew && _ctx.handleNew(...args)))
        }, "新增"),
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toCurPage && _ctx.toCurPage(...args)))
        }, "返回")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
        default: _withCtx(() => [
          _createVNode(_component_Table, {
            columns: _ctx.columns,
            "data-source": _ctx.tableData,
            rowKey: record=>record.id,
            scroll: {
              y: '6.6rem'
            },
            pagination: {
              total:_ctx.total,
              pageSize:_ctx.curPageSize,
              size:'small',
              current:_ctx.current,
              showQuickJumper: true,
              showSizeChanger:true,
              showTotal: (total) => `共 ${total} 条`,
              onChange: (page, pageSize) => _ctx.handleChange(page, pageSize),
              onShowSizeChange:(cur,size) => _ctx.sizeChange(cur,size),
            },
            bordered: ""
          }, {
            index: _withCtx(({ index,}) => [
              _createElementVNode("span", null, _toDisplayString(index + 1), 1)
            ]),
            biggerGreen: _withCtx(({ text,}) => [
              (!text || text[0] === '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "--/--"))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(text[0]) + "/", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(`${text[0]>text[1]?'red':'green'}`)
                    }, _toDisplayString(text[1] ===''?'--':text[1]), 3)
                  ]))
            ]),
            biggerRed: _withCtx(({ text,}) => [
              (!text || text[0] === '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "--/--"))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(text[0]) + "/", 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(`${text[0]<text[1]?'red':'green'}`)
                    }, _toDisplayString(text[1] ===''?'--':text[1]), 3)
                  ]))
            ]),
            op: _withCtx(({ text, }) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.handleEdit(text))
                }, "编辑", 8, _hoisted_11),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.handleDelete(text.id))
                }, "删除", 8, _hoisted_12),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.handleDetail(text))
                }, "详情", 8, _hoisted_13)
              ])
            ]),
            _: 1
          }, 8, ["columns", "data-source", "rowKey", "scroll", "pagination"])
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createVNode(_component_Modal, {
      "get-container": false,
      class: "edit-modal",
      footer: null,
      destroyOnClose: "",
      visible: _ctx.modalVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalVisible) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalVisible)
          ? (_openBlock(), _createBlock(_component_EditPop, {
              key: 0,
              popType: _ctx.popType,
              "item-info": _ctx.itemInfo,
              onCancel: _ctx.cancel,
              onSave: _ctx.save
            }, null, 8, ["popType", "item-info", "onCancel", "onSave"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}